module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/1749e6185a32d11ed7fc95fd1d6ab8aa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_latest.svg
// module id = JgJq
// module chunks = 0